<template>
  <div class="h-1 w-1 rounded-full" />
</template>
